var _rect, _rect2, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCardPlaid = function SvgCardPlaid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 26,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 39,
    height: 25,
    rx: 3.5,
    fill: "#fff"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 39,
    height: 25,
    rx: 3.5,
    stroke: "#F2F2F2",
    strokeWidth: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#card-plaid_svg__pattern0_48_19834)",
    d: "M18 10.5h18v5H18z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 11.926c0-.06.019-.12.053-.169l.443-.632a.294.294 0 0 1 .24-.125h2.081c.162 0 .294.132.294.294v3.412a.294.294 0 0 1-.294.294h-2.08a.294.294 0 0 1-.241-.126l-.443-.632A.294.294 0 0 1 3 14.075v-2.148Zm3.5-.632c0-.162.132-.294.294-.294h.967c.163 0 .295.132.295.294v1.245a.294.294 0 0 1-.295.294h-.967a.294.294 0 0 1-.294-.294v-1.245ZM8.739 11a.294.294 0 0 0-.295.294v1.745c0 .163.132.294.295.294h.967A.294.294 0 0 0 10 13.04v-1.745A.294.294 0 0 0 9.706 11h-.967ZM6.5 13.46c0-.162.132-.293.294-.293h.967c.163 0 .295.131.295.294v1.245A.294.294 0 0 1 7.76 15h-.967a.294.294 0 0 1-.294-.294V13.46Zm2.239.207a.294.294 0 0 0-.295.294v.745c0 .162.132.294.295.294h.967a.294.294 0 0 0 .294-.294v-.745a.294.294 0 0 0-.294-.294h-.967Z",
    fill: "#E7ECE9"
  })));
};
export default SvgCardPlaid;